import React from 'react';

// Luminance relative (WCAG) d'une couleur hex, ou null si illisible.
// (Copie locale de l'aide de personalization.ts.)
function relativeLuminance(hex: string): number | null {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split('').map((c) => c + c).join('') : m[1];
  const lin = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  const ch = (i: number) => lin(parseInt(h.slice(i, i + 2), 16) / 255);
  return 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4);
}

interface CoupleTheme {
  primaryColor?: string | null;
  fontFamily?: string | null; // police des titres
  bodyFont?: string | null; // police du texte
}

// Variables CSS locales aux couleurs / polices du couple. Utilisé quand les
// valeurs viennent des props (aperçu admin : valeurs en cours d'édition, pas
// encore appliquées globalement). À poser sur un élément portant .gu-theme,
// qui recalcule les teintes dérivées de --primary.
export function coupleThemeStyle({ primaryColor, fontFamily, bodyFont }: CoupleTheme): React.CSSProperties {
  const vars: Record<string, string> = {};
  const lum = primaryColor ? relativeLuminance(primaryColor) : null;
  if (primaryColor && lum !== null) {
    const onWhite = 1.05 / (lum + 0.05);
    const onDark = (lum + 0.05) / 0.062;
    vars['--primary'] = primaryColor;
    vars['--on-primary'] = onWhite >= onDark ? '#fff' : '#1c1b1a';
    vars['--ink-pct'] = lum > 0.2 ? '55%' : '80%';
  }
  if (fontFamily) vars['--gu-heading'] = `'${fontFamily}', var(--font-display)`;
  if (bodyFont) vars['--gu-body'] = `'${bodyFont}', var(--font-ui)`;
  return vars as React.CSSProperties;
}
